<template>
  <div class="mb-4">
    <label
      v-if="label"
      :class="clsx(
        ['select-none text-base/6 text-slate-950 sm:text-sm/6 font-medium'],
      )"
    >
      {{ label }}
    </label>
    <div class="relative mt-2">
      <div>
        <span
          :class="clsx(
            [
              'relative block w-full',
              'before:absolute before:inset-px before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-white before:shadow',
              // Focus ring
              'after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-inset after:ring-transparent sm:after:focus-within:ring-2 sm:after:focus-within:ring-primary-700',
              // Disabled state
              'has-[[disabled]]:opacity-50 before:has-[[disabled]]:bg-slate-950/5 before:has-[[disabled]]:shadow-none',
            ],
            error && 'before:shadow-red-500/10'
          )"
        >
          <input
            v-model="model"
            :type="pwdVisible ? 'text' : 'password'"
            v-bind="$attrs"
            :class="clsx(
              [
                // Basic layout
                'relative block w-full appearance-none rounded-lg px-[calc(theme(spacing[3.5])-1px)] py-[calc(theme(spacing[2.5])-1px)] sm:px-[calc(theme(spacing[3])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]',
                // Typography
                'text-base/6 text-slate-950 placeholder:text-slate-500 sm:text-sm/6',
                // Border
                'border',
                // Background color
                'bg-transparent',
                // Hide default focus styles
                'focus:outline-none focus:shadow-none focus:ring-0',
                // Disabled state
                '[disabled]:border-slate-950/20',
              ],
              error ? '!border-error hover:!border-error' : 'border-slate-950/10 hover:border-slate-950/20'
            )"
          />
        </span>

        <p
          v-if="description"
          :class="clsx(
            ['mt-2 text-base/6 text-slate-500 sm:text-sm/6'],
            $attrs.disabled && 'opacity-50'
          )"
        >
          {{ description }}
        </p>

        <p
          v-if="error"
          :class="clsx(
            ['text-base/6 text-error sm:text-sm/6'],
            $attrs.disabled && 'opacity-50',
            !description && 'mt-2'
          )"
        >
          {{ error }}
        </p>
      </div>

      <div
        class="absolute right-4 top-2 cursor-pointer text-base/6 text-slate-950 sm:text-sm/6 font-medium"
        @click="pwdVisible = !pwdVisible"
      >
        <span :class="[pwdVisible ? 'i-mdi-eye-off' : 'i-mdi-eye']"></span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import clsx from 'clsx'
import { PropType, ref } from 'vue'

const model = defineModel()

defineProps({
  label: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  },
  error: {
    type: String as PropType<any>,
    default: ''
  }
})

const pwdVisible = ref(false)

</script>
